export default __webpack_public_path__ + "cdfe24c53c22f72260b663456c01d9f6.png";